"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILPasswordField = void 0;
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var material_1 = require("@mui/material");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var ILPasswordField = function (_a) {
    var hideAdornment = _a.hideAdornment, children = _a.children, props = __rest(_a, ["hideAdornment", "children"]);
    var _b = react_1.default.useState(false), showPassword = _b[0], setShowPassword = _b[1];
    var handleClickShowPassword = function () {
        setShowPassword(!showPassword);
    };
    var adornment = (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
        react_1.default.createElement(IconButton_1.default, { "aria-label": "toggle password visibility", onClick: handleClickShowPassword, edge: "end", "data-testid": "showpassword-icon" },
            react_1.default.createElement(il_icon_common_1.SolidIcon, { size: enums_1.IconSizeEnum.XXSMALL, icon: showPassword ? solid_icon_definitions_1.SolidIconDefinitions.EYE_SLASH : solid_icon_definitions_1.SolidIconDefinitions.EYE }))));
    return (react_1.default.createElement(material_1.TextField, __assign({ placeholder: 'Password',
        size: enums_1.SizeEnum.SMALL,
        variant: enums_1.TextFieldVariantEnum.OUTLINED,
        color: enums_1.ColorPaletteEnum.PRIMARY,
        error: false,
        InputProps: {
            endAdornment: !hideAdornment && adornment,
        },
        type: showPassword ? 'text' : 'password' }, props), children));
};
exports.ILPasswordField = ILPasswordField;
